/**
 *
 * @param {TrackingAnalytics} analytics
 * @constructor
 */
function PostcodeTracker(analytics) {
    'use strict';

    this.analytics = analytics;
}

PostcodeTracker.prototype = {
    init: function () {
        'use strict';

        this.trackPostcodeEntry($('#postcode'));

        $('body').on('change', '.featherlight #shipping-postcode-prompt', this.trackPromptPostcode.bind(this));
    },

    /**
     * @param $field
     */
    trackPostcodeEntry: function ($field) {
        'use strict';
        if ($field.lenth) {
            $field.on('change', this.trackInput.bind(this, $field));
        }
    },

    /**
     * @param $field
     */
    trackInput: function ($field) {
        'use strict';
        this.analytics.track('Shipping', 'Postcode Entry', $field.val(), 1);
    },

    /**
     * @param event
     */
    trackPromptPostcode: function (event) {
        'use strict';

        var $postcode = $(event.target);
        this.trackInput($postcode);
    }
};

export default PostcodeTracker;